import { useState } from 'react'

import { useFloorPlan } from '../../hooks/useFloorPlan'
import { useSelector } from 'react-redux'

import { DragEventI, PanelContainer } from '@/components/ui'
import { CheckpointIProps } from '@/features/floor-plan'
import { selectMe } from '@/redux/me/meSlice'
import { mixpanel } from '@/utils/analytics'

import { CheckPointList } from './CheckPointList'
import { EditCheckPoint } from './EditCheckPoint'

export interface CheckPointsPanelIProps {
  facilityId: string
  floorId: string
  checkpoints: CheckpointIProps[]
  onTileDragStart: (event: DragEventI) => void
  onDeviceItemHoverIn: (deviceId: string) => void
  onDeviceItemHoverOut: () => void
}

export const CheckPointsPanel = ({
  floorId,
  facilityId,
  checkpoints,
  onTileDragStart,
  onDeviceItemHoverIn,
  onDeviceItemHoverOut,
}: CheckPointsPanelIProps) => {
  const me = useSelector(selectMe)
  const [editCheckPoint, setEditCheckPoint] = useState<CheckpointIProps>(null)
  const { setHighlightedDeviceIds } = useFloorPlan()

  const handleOnClick = (checkpoint: CheckpointIProps) => {
    setEditCheckPoint(checkpoint)
    mixpanel.track('Button Press: Checkpoint Details', {
      checkpoint_id: checkpoint.id,
      facility_id: facilityId,
      floor_id: floorId,
      role: me.roleName,
    })
  }

  const handleOnClose = () => {
    mixpanel.track('Button Press: Checkpoint Details - Edit Cancel', {
      checkpoint_id: editCheckPoint?.id,
      facility_id: facilityId,
      floor_id: floorId,
      role: me.roleName,
    })
    setEditCheckPoint(null)
    setHighlightedDeviceIds(null)
  }

  const handleOnDone = () => {
    mixpanel.track('Button Press: Checkpoint Details - Edit Save', {
      checkpoint_id: editCheckPoint?.id,
      facility_id: facilityId,
      floor_id: floorId,
      role: me.roleName,
    })
    setEditCheckPoint(null)
    setHighlightedDeviceIds(null)
  }

  return (
    <PanelContainer w='420px'>
      {editCheckPoint ? (
        <EditCheckPoint
          checkpoint={editCheckPoint}
          onClose={handleOnClose}
          onDone={handleOnDone}
        />
      ) : (
        <CheckPointList
          checkpoints={checkpoints}
          facilityId={facilityId}
          onCheckPointClick={handleOnClick}
          onDeviceItemHoverIn={onDeviceItemHoverIn}
          onDeviceItemHoverOut={onDeviceItemHoverOut}
          onTileDragStart={onTileDragStart}
        />
      )}
    </PanelContainer>
  )
}
